// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"673":"281f989a","767":"c8108171"}[chunkId] + ".chunk.js";
};